/**
 * Where a notification leads, if anywhere (the bell's panel and the /notifications page both ask). An explicit `href: null` means the
 * target is gone for good (a hard-deleted dossier), so the employeeId fallback must not resurrect a dead link.
 */
export function notificationHref(item) {
  const payload = (item && item.payload) || {};
  if (payload.href) return payload.href;
  if (payload.href === null) return '';
  return payload.employeeId ? `/agent-dossier?employee=${payload.employeeId}` : '';
}

export default notificationHref;
